import router from "@/router/index";
import {applicationEvents} from '@/utils/applicationEvents';
const Helpers = {
    emitter: applicationEvents,
    parseFiltersToParams(filters) {
        const params = {}
        console.log(filters)
        Object.entries(filters).forEach(([key, filterData]) => {
            if(filterData.value) {
                params[key] = filterData.value
            }
        });
        return params
    },

    addQueryToParams(query, params) {
        for (const key in query) {
            if (Object.prototype.hasOwnProperty.call(query, key)) {
                params[key] = query[key]
            }
        }
        return params
    },
    async setUrlQuery(query) {
        //important: copy object to force url change
        let currentQueries = Object.assign({}, router.currentRoute.value.query);
        await router.push({query: {...currentQueries, ...query}});
    },
    async removeQueryFromUrl(key) {
        //important: copy object to force url change
        let queries = Object.assign({}, router.currentRoute.value.query);
        // console.log(`remove: ${key}`, queries)
        delete queries[key]
        // console.log(`remove after: ${key}`, queries)
        await router.push({query: queries});
    },
}

export {Helpers};